import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyServicesData {
  serviceName: string;
  serviceDescription: string;
  serviceImage: string;
}

interface initialStateType {
  ar: CompanyServicesData;
  en: CompanyServicesData;
}

const initialState: initialStateType = {
  ar: {
    serviceName: '',
    serviceDescription: '',
    serviceImage: '',
  },
  en: {
    serviceName: '',
    serviceDescription: '',
    serviceImage: '',
  },
};

const companyServiceSlice = createSlice({
  name: 'companyServices',
  initialState,
  reducers: {
    clearCompanyServiceData: (state) => {
      state.ar = initialState.ar;
      state.en = initialState.en;
    },
    updateFieldValue: (
      state,
      action: PayloadAction<{
        language: 'ar' | 'en';
        field: string;
        value: any;
        isSameValue: boolean;
      }>,
    ) => {
      const { language, field, value, isSameValue } = action.payload;
      state[language][field] = value;
      if (isSameValue) {
        state['ar'][field] = value;
        state['en'][field] = value;
      }
    },
  },
});

export const { updateFieldValue, clearCompanyServiceData } =
  companyServiceSlice.actions;

export const companyServicesReducer = companyServiceSlice.reducer;

export interface CompanyServiceState extends initialStateType {}
